// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3JUWN","emails":"CreateEditClinics_emails__ebzpZ","emailTagLabel":"CreateEditClinics_emailTagLabel__RfNS3"};